<i18n>
{
    "ru": {
        "guest": "Гость"
    }
}
</i18n>

<template>
    <span></span>
</template>

<script>

import dayjs from 'dayjs'
import get from 'lodash/get'

export default {
    name: 'MicroMarkup',
    props: {
        type: {
            type: String,
            default: ''
        },
        headline: {
            // название статьи – содержимое заголовка h1
            type: String,
            default: ''
        },
        datePublished: {
            // дата публикации статьи
            type: String,
            default: ''
        },
        dateModified: {
            // дата последнего изменения статьи
            type: String,
            default: ''
        },
        image: {
            // ссылка на иллюстрирующее изображение
            type: String,
            default: ''
        },
        articleSection: {
            //  раздел, к которому прикреплена конкретная статья
            type: String,
            default: ''
        },
        articleBody: {
            // содержимое статьи
            type: String,
            default: ''
        },
        name: {
            // имя автора, который готовил конкретный материал
            type: String,
            default: ''
        },
        productName: {
            // название товара
            type: String,
            default: ''
        },
        pictures: {
            // ссылки на фотографии товара
            type: Array,
            default: () => []
        },
        description: {
            // описание товара
            type: String,
            default: ''
        },
        brandName: {
            // название бренда
            type: String,
            default: ''
        },
        reviews: {
            // отзывы
            type: Array,
            default: () => []
        },
        ratings: {
            // рейтинг
            type: Object,
            default: () => {}
        }
    },
    computed: {
        output(){

            let type = ''
            let data = {}

            switch(this.type){
            case 'news':
                type = 'NewsArticle'
                break
            case 'perfume':
                type = 'Product'
                break
            case 'brand':
                type = 'Organization'
                break
            case 'glossary':
                type = 'FAQPage'
                break
            default:
                type = 'Article'
            }

            if(type === 'NewsArticle' || type === 'Article'){
                const id = this.$route.fullPath // относительный адрес текущей статьи
                const url = this.$i18n.__baseUrl + this.$route.fullPath
                const logo = this.$i18n.__baseUrl + '/img/logo.png' // полный путь до лого в формате png
                const datePublished = dayjs(this.datePublished).format('YYYY-MM-DD')
                const dateModified = dayjs(this.dateModified).format('YYYY-MM-DD')

                data = {
                    '@context': 'https://schema.org',
                    '@type': type,
                    mainEntityOfPage: {
                        '@type': 'WebPage',
                        '@id': id
                    },
                    publisher: {
                        "@type": 'Organization',
                        name: 'Aromo',
                        logo: {
                            '@type': 'ImageObject',
                            url: logo
                        }
                    },
                    headline: this.headline,
                    datePublished,
                    dateModified,
                    image: this.image,
                }

                if(this.articleSection)
                    data.articleSection = this.articleSection

                data = {
                    ...data,
                    articleBody: this.prepareContent(this.articleBody),
                    url,
                    author: {
                        "@type": 'Person',
                        name: this.name
                    }
                }
            }

            if(type === 'Product'){

                const images = this.pictures.length && this.pictures[0].url ? 
                    this.pictures.map(image => image.url) :
                    [this.$i18n.__baseUrl + '/img/perfumeNoImage.png']

                data = {
                    '@context': 'https://schema.org/',
                    '@type': 'Product',
                    name: this.productName,
                    image: images,
                    description: this.prepareContent(this.description),
                    brand: {
                        '@type': 'Brand',
                        name: this.brandName
                    }
                }

                // назначаем параметр отзывов только если они есть
                if(this.reviews.length){
                    const reviews = this.reviews.filter(review => review.stars).map(review => {
                        return {
                            '@type': 'Review',
                            reviewRating: {
                                '@type': 'Rating',
                                ratingValue: review.stars,
                                bestRating: 5,
                                worstRating: 0
                            },
                            author: {
                                '@type': 'Person',
                                'name': get(review, 'createdBy.fullName', this.$t('guest'))
                            },
                            reviewBody: review.text
                        }
                    })

                    data.review = reviews
                }

                data.aggregateRating = {
                    '@type': 'AggregateRating',
                    ratingValue: this.ratings.value,
                    reviewCount: this.ratings.total,
                    bestRating: 5,
                    worstRating: 0
                }
            }

            if(type === 'Organization'){
                data = {
                    '@context': 'http://schema.org',
                    '@type': type,
                    name: this.brandName,
                    review: {
                        '@type': 'Review',
                        author: {
                            '@type': type,
                            name: 'Aromo',
                            url: 'https://aromo.ru/'
                        },
                        reviewRating: {
                            '@type': 'Rating',
                            ratingValue: get(this.ratings, 'value', 0),
                            bestRating: 5,
                            worstRating: 1
                        }
                    }
                }
            }

            if(type === 'FAQPage'){
                data = {
                    '@context': 'https://schema.org',
                    '@type': type,
                    mainEntity: [{
                        '@type': 'Question',
                        name: this.headline,
                        acceptedAnswer: {
                            '@type': 'Answer',
                            text: this.prepareContent(this.description)
                        }
                    }]
                }
            }

            return data
        }
    },
    methods: {
        prepareContent(content){
            return content.replace(/<\/?[^>]+>/gi, ' ')
                .replace(/(\r\n|\n|\r|\t)/gi, ' ')
                .replace(/\s\s+/g, ' ')
                .trim()
        }
    },
    head(){
        return {
            script: [{
                type: 'application/ld+json',
                json: this.output
            }]
        }
    }
}
</script>